/**
 * FAQ System – client-side category filtering for the FAQ page.
 *
 * Expects markup produced by main-faq-page.liquid:
 *   data-faq-filter  on the filter container
 *   data-faq-category  on each <button> (empty string = "all")
 *   data-faq-tags  on each .faq-item (comma-separated lowercase tags)
 *   data-faq-empty  on a "no results" element
 */

(function () {
  'use strict';

  function initFaqFilter(container) {
    const buttons = container.querySelectorAll('[data-faq-category]');
    const items   = document.querySelectorAll('.faq-item[data-faq-tags]');
    const empty   = document.querySelector('[data-faq-empty]');

    if (!buttons.length || !items.length) return;

    function applyFilter(category) {
      let visible = 0;

      items.forEach(function (item) {
        if (category === '') {
          item.classList.remove('faq-item--hidden');
          visible++;
          return;
        }

        const tags = (item.dataset.faqTags || '').split(',').map(function (t) {
          return t.trim();
        });

        if (tags.indexOf(category) !== -1) {
          item.classList.remove('faq-item--hidden');
          visible++;
        } else {
          item.classList.add('faq-item--hidden');
          // Close the accordion if it was open
          var details = item.querySelector('details');
          if (details) details.removeAttribute('open');
        }
      });

      if (empty) {
        empty.style.display = visible === 0 ? '' : 'none';
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const category = btn.dataset.faqCategory;

        // Update active state
        buttons.forEach(function (b) {
          b.classList.toggle('faq-filter__btn--active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });

        applyFilter(category);
      });
    });
  }

  // Initialise on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    const filterBar = document.querySelector('[data-faq-filter]');
    if (filterBar) initFaqFilter(filterBar);
  });
})();
